module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.playlist) ? _c('v-layout', [_c('v-flex', [_c('h1', {
    staticClass: "display-1"
  }, [_vm._v(_vm._s(_vm.playlist.title))]), _vm._v(" "), _vm._l((_vm.playlist.tracks), function(track) {
    return _c('div', {
      key: track.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Track',
          params: {
            id: track.id
          }
        }
      }
    }, [(track.edits[0]) ? _c('span', [_vm._v(_vm._s(track.edits[0].name))]) : _c('span', [_vm._v(_vm._s(track.name))]), _vm._v(" -\n                "), (track.edits[0]) ? _c('span', [_vm._v(_vm._s(track.edits[0].artist))]) : _c('span', [_vm._v(_vm._s(track.artist))])]), _vm._v(" "), _c('div', {
      staticClass: "divider"
    })], 1)
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b866bd00","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PagePlaylistEdit.vue
// module id = 397
// module chunks = 0